import * as maplibregl from 'maplibre-gl';
import { Map } from '../../..';
import { LocalizationService } from '../../../services/RM2LocalizationService';
import { ServiceType } from '../../../services/RM2Service';
import Mustache from 'mustache';
import { MapBackgroundSwitchTemplate } from '../templates/map-background-switch-template';

export class RM2PrometSiMapBackgroundSwitchControl implements maplibregl.IControl {

    private _localizationService: LocalizationService;
    private _wrapper: HTMLDivElement;

    constructor(map: Map) {
        this._localizationService = map.getService(ServiceType.Localization) as LocalizationService;
    }
    
    onAdd(map: maplibregl.Map): HTMLElement {

        this._wrapper = document.createElement('div');
        this._wrapper.className = 'maplibregl-ctrl';
        this._wrapper.innerHTML = Mustache.render(MapBackgroundSwitchTemplate, {});
        this._localizationService.refresh(this._wrapper);

        return this._wrapper;
    }

    onRemove(map: maplibregl.Map): void {
        this._wrapper.parentNode.removeChild(this._wrapper);
    }

    getDefaultPosition() : maplibregl.ControlPosition {
        return 'bottom-left';
    }

    public getWrapper()
    { return this._wrapper; }
};
